let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6kLPy")).then(() => parcelRequire('9S9DZ'));